import React from 'react';
import styled from 'styled-components';
import { FormattedCurrency } from 'i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tooltip from 'rc-tooltip';
import PriceBreakdown from 'routes/checkoutPage/steps/otherExtras/components/common/PriceBreakdownComponent';

function SelectedOtherExtrasComponent({ icon, description, price, tax }) {
  const totalPrice = (
    <Price>
        +
        <FormattedCurrency value={price} />
    </Price>
  );

  const priceBreakdown = (
    <PriceBreakdown price={price} tax={tax}/>
  )

  return (
    <Root>
      <Description>
        <Icon icon={icon} />
        {description}
      </Description>
      {price !== 0 && (
        tax ? (
          <PriceInfo>
            <Tooltip placement='top' trigger={['hover']} overlayStyle={{ opacity: 1, width: '100%', maxWidth: '150px' }} overlay={priceBreakdown} destroyTooltipOnHide>
              <Info icon='info-circle' />
            </Tooltip>
            {totalPrice}
          </PriceInfo>
        ) : (totalPrice)
      )}
      
    </Root>
  );
}

export default SelectedOtherExtrasComponent;

const Root = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Icon = styled(FontAwesomeIcon)``;

const Description = styled.div`
  font-size: 1.2em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.colors.text.default};
  font-weight: 500;

  ${Icon} {
    margin-right: 10px;
    color: ${({ theme }) => theme.colors.buttons.grey};
  }
`;

const Price = styled.div`
  font-size: 1.2em;
  color: ${({ theme }) => theme.colors.text.default};
  font-weight: bold;
`;

const Info = styled(FontAwesomeIcon)`
  margin: 0px 6px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text.default};
`;

const PriceInfo = styled.div`
  display: flex;
`